import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import firebase from "firebase/app";
import { functions } from "config/firebase";
import useMensajeGlobal from "hooks/useMensajeGlobal";
import useProgressSpinner from "hooks/useProgressSpinner"
import NeoTitleMain from "design/design_components/neo/title/NeoTitleMain.base";
import FormularioCuentaUsuario from "components/common/FormularioCuentaUsuario";
import NeoButtonSection from "design/design_components/neo/layout/NeoButtonSection.base";
import NeoButtonMain from "design/design_components/neo/button/NeoButtonMain.base";
import NeoGridContainer from "design/design_components/neo/layout/NeoGridContainer.base";
import NeoDialogConfirm from "design/design_components/neo/overlay/NeoDialogConfirm.base";
import { useComponent } from "hooks";
import useCliente from "hooks/useCliente";
import Icono from 'design/assets/img/mnv/icons/icon-config.svg';
import TarjetaDatosPersonales from "components/common/TarjetaDatosPersonales";

const listadoPlanes = functions.httpsCallable("listadoPlanes");

const clienteSobregiroObtener = functions.httpsCallable("clienteSobregiro-obtener");

const obtienePreciosCliente = functions.httpsCallable("precios-obtienePrecioPorClienteParaAdmin");


const ClientesEditar = (props) => {
    const componente = useComponent();
    const cliente = useCliente();
    const [, setSpinnerCargando] = useProgressSpinner(true)
    const despliegaMensaje = useMensajeGlobal();
    const [listaPlanes, setListaPlanes] = componente.useCustomState([]);
    const [sobregiro, setSobregiro] = componente.useCustomState([]);
    let historial = useHistory();
    const [muestraDialogoContrasena, setMuestraDialogoContrasena] = componente.useCustomState(false);
    const [preciosCliente, setPreciosCliente] = componente.useCustomState();
    const [permiteEditarPrecios,] = componente.useCustomState(false);

    const [seGuardoDatos, setSeGuardoDatos] = componente.useCustomState(false);
    const [seGuardoPrecios, setSeGuardoPrecios] = componente.useCustomState(false);

    const guardaDatosCliente = componente.useAsync(functions.httpsCallable("setDatosCliente"));
    const guardaPreciosCliente = componente.useAsync(functions.httpsCallable("precios-establecePrecioPorClienteParaAdmin"));

    useEffect(() => {
        return () => { componente.desmontar(); };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps



    useEffect(() => {
        obtienePlanes();
        obtienePrecios();
        obtieneSobregiroValidaciones();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const obtienePlanes = () => {
        listadoPlanes().then((resp) => {
            setListaPlanes(resp.data);
        }).catch((error) => {
            console.log("Error: ", error);
            despliegaMensaje({
                severity: "error",
                summary: "Error",
                detail: error.message
            });
        }).finally(() => {
            setSpinnerCargando(false);
        });
    };

    const obtienePrecios = () => {
        // if (cliente?.plan?.nombre === "postpago") {
        //     setPermiteEditarPrecios(true);
        // }

        obtienePreciosCliente({
            clienteId: cliente.id
        }).then((resp) => {
            setPreciosCliente(resp.data)
        }).catch((error) => {
            console.log("Error: ", error);
            despliegaMensaje({
                severity: "error",
                summary: `Error: ${error.code}`,
                detail: error.message
            });
        })
    };

    const obtieneSobregiroValidaciones = async () => {
        let respuesta = await clienteSobregiroObtener({
            clienteId: cliente.id
        }).catch((error) => {
            console.log("Error: ", error);
            despliegaMensaje({
                severity: "error",
                summary: "Error al obtener sobregiro de validaciones",
                detail: error.message
            });
        });

        if (respuesta) {
            setSobregiro(respuesta.data);
        }
    };

    useEffect(() => {
        if (seGuardoPrecios && seGuardoDatos) {
            despliegaMensaje({
                severity: "success",
                summary: "Configuraciones del usuario",
                detail: "Han sido guardadas correctamente",
            });
            // historial.goBack();
            setSeGuardoDatos(false);
            setSeGuardoPrecios(false);
        }
    }, [seGuardoPrecios, seGuardoDatos]); // eslint-disable-line react-hooks/exhaustive-deps


    const pideRestablecerContrasena = (datos) => {
        firebase.auth().sendPasswordResetEmail(
            cliente.correo
        ).then((result) => {
            despliegaMensaje({
                severity: "success",
                summary: "",
                detail: "Se ha enviado el correo para restablecer la contraseña"
            });
        }).catch((error) => {
            despliegaMensaje({
                severity: "error",
                summary: "Error",
                detail: "Hubo un error al enviar el correo."
            });
        });
    }

    const manejaConsultarBitacora = () => {
        return historial.push("/administracion/clientes/bitacora");
    };

    const guardaDatos = (datos) => {

        guardaDatosCliente({
            ...datos,
            clienteId: Number(cliente.id)
        }).then(() => {
            setSeGuardoDatos(true);
            //Actualiza el usuario en el componente padre
            cliente.recargar();
        }).catch((error) => {
            console.log("Error: ", error);
            despliegaMensaje({
                severity: "error", summary: "",
                detail: `${error.message} (${error.code})`
            });
        }).finally(() => {
            obtieneSobregiroValidaciones();
        });

        guardaPreciosCliente({
            preciosCliente,
            clienteId: Number(cliente.id)
        }).then(() => {
            setSeGuardoPrecios(true);
        }).catch((error) => {
            console.log("Error: ", error);
            despliegaMensaje({
                severity: "error", summary: "",
                detail: `${error.message} (${error.code})`
            });
        });

        // guardaSobregiro(datos.sobregiroValidaciones);
    }



    return (<>
        <NeoGridContainer>
            <NeoTitleMain icon={Icono} title="Cuenta del usuario" col="12" md="6" />

            <NeoButtonSection align="right" col="12" md="6"
                extra="p-col-align-center p-flex-sm-row p-flex-column">
                <NeoButtonMain label="Cambiar contraseña"
                    onClick={() => setMuestraDialogoContrasena(true)} />
                <NeoButtonMain label="Consultar bitácora"
                    onClick={manejaConsultarBitacora} />
            </NeoButtonSection>
        </NeoGridContainer>


        {/* Datos personales, estado, Growth Marketer y Salesforce se editan en NeoAdmin */}
        <TarjetaDatosPersonales
            datos={cliente}
            vistaEjecutivo={true}
        />

        <FormularioCuentaUsuario
            datos={{
                ...cliente,
                listaPlanes: listaPlanes
            }}
            vistaCliente={false}
            precios={preciosCliente}
            preciosEditables={permiteEditarPrecios}
            onSubmit={guardaDatos}
            asignacionDnEditable={true}
            onCambiarContrasena={pideRestablecerContrasena}
            sobregiroValidaciones={sobregiro}
            loading={componente.isLoading}
        />

        <NeoDialogConfirm visible={muestraDialogoContrasena}
            onHide={() => setMuestraDialogoContrasena(false)}
            message="Se te enviará un correo con instrucciones para cambiar tu contraseña. ¿Deseas proceder?"
            header="Confirmación" icon="pi pi-exclamation-triangle"
            accept={pideRestablecerContrasena} />
    </>);
};


export default ClientesEditar;